const ProductData = [
	{
		id:1403552,
		img: "https://rukminim1.flixcart.com/image/832/832/j9d3bm80/headphone/z/s/f/bose-quietcomfort-35-ii-original-imaeyzzctgygz4pf.jpeg?q=50",
	    name: "Quietcomfort 35 II",
		brand: "Bose",
		price: 29363,
		rating:4.6,
	    microphone:"Yes" ,
	    connectivity :"bluetooth",
	    type : "Over the Ear",
	    
	},
	{
		id:1403542,
		img: "https://rukminim1.flixcart.com/image/832/832/j58hj0w0/headset/extra-bass/q/5/y/sony-mdr-xb450ap-original-imaevftn67xkznr2.jpeg?q=50",
	    name: "XB450",
		brand: "Sony",
		price: 1849,
		rating:4.3,
	    microphone:"Yes" ,
	    connectivity :"wired",
	    type : "Over the Ear",
	    
	},
	{
		id:1403446,
		img: "https://rukminim1.flixcart.com/image/832/832/j2m6gsw0/headset/z/7/5/sennheiser-hd-4-40bt-original-imaetxdzqw7qhtey.jpeg?q=50",
	    name: "HD 4.40BT",
		brand: "Sennheiser",
		price: 7490,
		rating:4.4,
	    microphone:"Yes" ,
	    connectivity :"bluetooth",
	    type : "Over the Ear",
	    
	},
	{
		id:1403476,
		img: "https://rukminim1.flixcart.com/image/832/832/jusp3m80/headphone/e/d/x/sennheiser-pc-8-usb-original-imaffuguh5z6dnxn.jpeg?q=50",
	    name: "PC 8 USB",
		brand: "Sennheiser",
		price: 2490,
		rating:4.5,
	    microphone:"Yes" ,
	    connectivity :"wired",
	    type : "On the Ear",
	    
	},
	{
		id:1403176,
		img: "https://rukminim1.flixcart.com/image/832/832/jgy0fbk0/headphone/dynamic/s/e/g/jbl-c150siured-original-imaf52ve4qyx5j4w.jpeg?q=50",
	    name: "C150SI",
		brand: "JBL",
		price: 699,
		rating:2.5,
	    microphone:"Yes" ,
	    connectivity :"wired",
	    type : "In the Ear",
	    
	},
	{
		id:1403186,
		img: "https://rukminim1.flixcart.com/image/832/832/jkk1hu80/headphone/5/n/a/jbl-e25bt-original-imaf7vzp8sfkxdfx.jpeg?q=50",
	    name: "E25BT",
		brand: "JBL",
		price: 2499,
		rating:3.7,
	    microphone:"Yes" ,
	    connectivity :"bluetooth",
	    type : "In the Ear",
	    
	},
	{
		id:1407136,
		img: "https://rukminim1.flixcart.com/image/832/832/jcrz6vk0/headphone/t/y/v/bose-soundsport-free-original-imaffuypaguzz69q.jpeg?q=50",
	    name: "Soundsport Free",
		brand: "Bose",
		price: 18990,
		rating:4.3,
	    microphone:"Yes" ,
	    connectivity :"bluetooth",
	    type : "In the Ear",
	    
	},
	{
		id:1447574,
		img: "https://rukminim1.flixcart.com/image/832/832/jv8exzk0/headphone/u/s/j/sony-wh-xb700-original-imafg6sezz6uf492.jpeg?q=50",
	    name: "WH-XB700",
		brand: "Sony",
		price: 8790,
		rating:3.9,
	    microphone:"Yes" ,
	    connectivity :"bluetooth",
	    type : "Over the Ear",
	    
	},
	{
		id:1448564,
		img: "https://rukminim1.flixcart.com/image/832/832/jb5e4y80/headphone/h/3/p/sony-wh-h900n-original-imafykgfxmafgena.jpeg?q=50",
	    name: "H900N Digital Noise Cancellation",
		brand: "Sony",
		price: 16999,
		rating:4.6,
	    microphone:"Yes" ,
	    connectivity :"bluetooth",
	    type : "Over the Ear",
	    
	}


];

export default ProductData;